<template>
  <div class="skeleton recently-active-skel">
    <div class="recently-active-skel__wrapper">
      <div class="skeleton__animate recently-active-skel__box">
        <p class="skeleton__animate--white recently-active-skel__title"></p>
        <p class="skeleton__animate--white recently-active-skel__bottom"></p>
      </div>
      <div class="skeleton__animate recently-active-skel__box">
        <p class="skeleton__animate--white recently-active-skel__title"></p>
        <p class="skeleton__animate--white recently-active-skel__bottom"></p>
      </div>
      <div class="skeleton__animate recently-active-skel__box">
        <p class="skeleton__animate--white recently-active-skel__title"></p>
        <p class="skeleton__animate--white recently-active-skel__bottom"></p>
      </div>
      <div class="skeleton__animate recently-active-skel__box">
        <p class="skeleton__animate--white recently-active-skel__title"></p>
        <p class="skeleton__animate--white recently-active-skel__bottom"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HuluCarouselSkel',
}
</script>

<style lang="scss" scoped>
.recently-active-skel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  @include tablet {
    padding: 50px 0 50px 100px;
  }
  &__wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    @include tablet {
      flex-wrap: nowrap;
    }
  }
  &__box {
    margin: 0 10px;
    width: 25%;
    height: 386px;
    position: relative;
    border-radius: 5px;
  }
  &__title {
    margin: 30px 10px 0 10px;
    width: 220px;
    height: 18px;
  }
  &__bottom {
    position: absolute;
    bottom: 15px;
    left: 10px;
    height: 18px;
    width: 100px;
  }
}
</style>
